import React, { ReactNode } from 'react';

import style from './TitleBar.module.scss';

interface Props {
  children?: ReactNode;
  title: string;
  loading: boolean;
}

export default function TitleBar({
  children,
  title,
  loading,
}: Props): React.ReactElement {
  return (
    <div
      className={style['component-wrapper']}
    >
      <p
        className={style['title']}
      >
        {title} 
      </p>
      {loading && <div
        className={style['loading-spinner']}
      />}
      <div
        className={style['content']}
      >
        {children}
      </div>
    </div>
  )
}